import React, { useEffect } from 'react';
import Layout from '../layout/Layout';
import { usePageContent } from '../../context/ContentContext';

const OurValues = () => {
    const { t } = usePageContent('ourValues');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout>
            {/* Hero Section */}
            <section className="relative h-[70vh] overflow-hidden">
                <img
                    src={t('hero.image')}
                    alt={t('hero.title')}
                    className="absolute inset-0 w-full h-full object-cover"
                />
                {/* Lighter overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40 flex items-center justify-center">
                    <h1 className="font-poppins font-light text-h1 text-white text-center px-4">
                        {t('hero.title')}
                    </h1>
                </div>
            </section>

            {/* Mission Statement */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto text-center">
                        <h2 className="font-poppins font-light text-h2 mb-8 text-primary-dark-red">
                            {t('mission.title')}
                        </h2>
                        <div className="font-poppins font-normal text-body">
                            {t('mission.paragraphs').map((paragraph, index) => (
                                <p key={index} className="mb-6 last:mb-0">{paragraph}</p>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Core Values */}
            <section className="py-20 bg-background-cool-blue">
                <div className="container mx-auto px-4">
                    <h2 className="font-poppins font-light text-h2 text-center mb-12 text-primary-dark-red">
                        {t('values.title')}
                    </h2>

                    <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
                        {t('values.cards').map((card, index) => (
                            <div key={index} className="text-center bg-white p-6 rounded-lg">
                                <div className="mb-6 flex justify-center h-24">
                                    <img
                                        src={card.image}
                                        alt={card.title}
                                        className="h-full w-auto object-contain"
                                    />
                                </div>
                                <h3 className="font-poppins font-semibold text-h3 mb-4 text-primary-red">{card.title}</h3>
                                <p className="font-poppins font-normal text-body text-gray-700">
                                    {card.body}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Knitstory - Founders Section */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="font-poppins font-light text-h2 text-center mb-12 text-primary-dark-red">
                        {t('founders.title')}
                    </h2>
                    <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
                        {t('founders.people').map((person, index) => (
                            <div key={index} className="bg-accent-powder-green p-6 rounded-lg">
                                <div className="relative overflow-hidden mb-6 aspect-[3/4] rounded-lg">
                                    <img
                                        src={person.image}
                                        alt={person.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <h3 className="font-poppins font-semibold text-h3 mb-2">{person.name}</h3>
                                <p className="font-poppins font-normal text-body text-primary-red mb-4">{person.role}</p>
                                <p className="font-poppins font-normal text-body text-gray-700">
                                    {person.bio}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default OurValues;
